function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Form, Drawer, Breadcrumb, Descriptions, Modal, DatePicker, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, CalendarCheckFill, CardImage, PencilSquare, PersonCheckFill, Clipboard2Pulse, GraphUpArrow, HourglassSplit, Upload as UploadIc, ImageFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import NewConsultation from "../components/forms/NewConsultation";
import PatientView from "../components/PatientView";
import Moment from 'react-moment';
import SetImResult from "../components/forms/SetImResult";
import SetImFile from "../components/forms/SetImFile";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var DepartmentQueueDisplay = function DepartmentQueueDisplay(_ref) {
  var dcode = _ref.dcode,
    longName = _ref.longName;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItem = _useState0[0],
    setCurrentQueueItem = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isConsultationDrawerVisible = _useState10[0],
    setIsConsultationDrawerVisible = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    searchId = _useState12[0],
    setSearchId = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isPatientModalOpen = _useState14[0],
    setIsPatientModalOpen = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    dataChanged = _useState16[0],
    setDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showCheck = _useState18[0],
    setShowCheck = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showTranslate = _useState20[0],
    setShowTranslate = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showImageInput = _useState22[0],
    setShowImageInput = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedItem = _useState24[0],
    setSelectedItem = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showPatientRecord = _useState26[0],
    setShowPatientRecord = _useState26[1];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
      //setIsPatientModalOpen(true); 
    }
  };
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        dep = response.data.departments.filter(function (d) {
          return d.dcode == dcode;
        });

        //let dep = response.data.departments.filter(d => d.dcode == 'CON');    
        var req;
        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString();
        }
        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString();
        }
        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
          console.log(qresponse.data.queueData);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Breadcrumb, {
            children: [/*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: "File"
            }), /*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                children: longName
              })
            })]
          }), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " En attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Num. Salle"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("div", {
                                children: e.im_result != null && /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: /*#__PURE__*/_jsx("b", {
                                    children: e.im_result.translator.nickname
                                  })
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "#f50",
                                style: {
                                  cursor: "pointer"
                                },
                                onClick: function onClick() {
                                  setCurrentQueueItem(q);
                                  setShowImageInput(true);
                                  setSelectedItem(e.medical_item);
                                },
                                children: e.medical_item.label
                              });
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PersonCheckFill, {
                  size: 35
                }), " Re\xE7u"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Num. Salle"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("div", {
                                children: e.im_result != null && /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: /*#__PURE__*/_jsx("b", {
                                    children: e.im_result.translator.nickname
                                  })
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "#f50",
                                style: {
                                  cursor: "pointer"
                                },
                                onClick: function onClick() {
                                  setCurrentQueueItem(q);
                                  setShowImageInput(true);
                                  setSelectedItem(e.medical_item);
                                },
                                children: e.medical_item.label
                              });
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isConsultationDrawerVisible,
      title: "Nouvelle consultation",
      width: 370,
      onClose: function onClose() {
        setIsConsultationDrawerVisible(false);
      },
      closable: true,
      children: currentQueueItem != null && /*#__PURE__*/_jsx(NewConsultation, {
        handler: function handler() {
          setDataChanged(true);
        },
        queueId: currentQueueItem.id,
        queueData: queueData,
        patient: currentQueueItem.customer
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["DOSSIER PATIENT N\xBA ", searchId]
      }),
      destroyOnClose: true,
      footer: null,
      open: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    })]
  });
};
export default DepartmentQueueDisplay;